"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.UP = exports.TAB = exports.SPACE = exports.ESC = exports.ENTER = exports.DOWN = void 0;
var _react = _interopRequireDefault(require("react"));

// keycodes for keyboard events.
var TAB = 9;
exports.TAB = TAB;
var ENTER = 13;
exports.ENTER = ENTER;
var SPACE = 32;
exports.SPACE = SPACE;
var ESC = 27;
exports.ESC = ESC;
var UP = 38;
exports.UP = UP;
var DOWN = 40;
exports.DOWN = DOWN;